import { DriveStep } from 'driver.js';

export function buildTourSteps(subscriptionsEnabled: boolean): DriveStep[] {
  const steps: DriveStep[] = [
    {
      element: '[data-tour="nav-dashboard"]',
      popover: {
        title: 'Dashboard',
        description: 'Your home base. See active API keys, recent usage, and credit balance at a glance — plus quick-start links to get your first API call running.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="nav-api-keys"]',
      popover: {
        title: 'API Keys',
        description: 'Create and manage the keys your applications use to call the API. Each key has independent model selection rules, priority settings, tag-based filtering, and spend limits.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="nav-usage"]',
      popover: {
        title: 'Usage',
        description: 'Track token consumption, request counts, and cost trends over time. Charts are broken out per API key so you can see exactly which integration is driving traffic.',
        side: 'bottom',
        align: 'start',
      },
    },
  ];

  if (subscriptionsEnabled) {
    steps.push({
      element: '[data-tour="nav-plans"]',
      popover: {
        title: 'Plans & Billing',
        description: 'Choose or upgrade your subscription tier, view current plan limits, and manage billing details. Limits are enforced per API key so you stay in control of spend.',
        side: 'bottom',
        align: 'start',
      },
    });
  }

  steps.push(
    {
      element: '[data-tour="nav-models"]',
      popover: {
        title: 'Models',
        description: 'Register AI models and configure their flags — rank, privacy-compliant, Task Determination model, and custom tag support. Build curated Model Lists here to restrict specific keys to approved models only.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="nav-api-reference"]',
      popover: {
        title: 'API Reference',
        description: 'Full documentation for every endpoint — request schemas, authentication headers, response formats, and code examples ready to drop into your integration.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="nav-category-rules"]',
      popover: {
        title: 'Category Rules',
        description: 'Define custom classification tags (e.g. "marketing", "legal") that Task Determination evaluates on every query. Enable tag-based filtering per API key to route specific query types to the right models automatically.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="nav-guide"]',
      popover: {
        title: 'Need more help?',
        description: 'Click the help icon any time to open the Guide — a full deep-dive into Task Determination, Model Lists, Category Rules, and step-by-step setup recipes. You can also restart this tour from there.',
        side: 'bottom',
        align: 'end',
      },
    }
  );

  return steps;
}
